/* =============================================
   Avalna Card Swipe — Batch 16
   Product card image carousel with dot indicators
   ============================================= */

(function () {
  'use strict';

  var SWIPE_THRESHOLD = 30;

  function avalnaCardSwipeInit() {
    var cards = document.querySelectorAll('.avalna-card-swipe');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          avalnaLoadCardImages(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    var isDesktop = window.matchMedia('(min-width: 750px)').matches;

    cards.forEach(function (card) {
      observer.observe(card);
      if (isDesktop) {
        avalnaBindHover(card);
      } else {
        avalnaBindSwipe(card);
        avalnaBindDots(card);
      }
      avalnaBindTapNav(card);
    });
  }

  function avalnaLoadCardImages(card) {
    var images = card.querySelectorAll('.avalna-card-swipe__img[data-avalna-card-swipe-src]');
    images.forEach(function (img) {
      var src = img.getAttribute('data-avalna-card-swipe-src');
      var srcset = img.getAttribute('data-avalna-card-swipe-srcset');
      if (src) {
        img.src = src;
        img.removeAttribute('data-avalna-card-swipe-src');
      }
      if (srcset) {
        img.srcset = srcset;
        img.removeAttribute('data-avalna-card-swipe-srcset');
      }
    });
  }

  function avalnaBindSwipe(card) {
    var startX = 0;
    var startY = 0;
    var locked = false;
    var isHorizontal = null;

    card.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      locked = false;
      isHorizontal = null;
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (locked) return;
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 10 || dy > 10) {
        isHorizontal = dx > dy;
        locked = true;
      }
    }, { passive: true });

    card.addEventListener('touchend', function (e) {
      if (!isHorizontal) return;
      var endX = e.changedTouches[0].clientX;
      var dx = endX - startX;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;

      var images = card.querySelectorAll('.avalna-card-swipe__img');
      var dots = card.querySelectorAll('.avalna-card-swipe__dot');
      var currentIndex = avalnaGetActiveIndex(images);
      var newIndex;

      if (dx < 0 && currentIndex < images.length - 1) {
        newIndex = currentIndex + 1;
      } else if (dx > 0 && currentIndex > 0) {
        newIndex = currentIndex - 1;
      }

      if (newIndex !== undefined) {
        avalnaLoadCardImages(card);
        avalnaSetActiveImage(images, dots, newIndex);
        e.preventDefault();
      }
    }, { passive: false });
  }

  function avalnaBindTapNav(card) {
    card.addEventListener('click', function (e) {
      if (e.target.classList.contains('avalna-card-swipe__dot')) return;
      var url = card.getAttribute('data-avalna-card-swipe-url');
      if (url) window.location.href = url;
    });
  }

  function avalnaBindDots(card) {
    var dots = card.querySelectorAll('.avalna-card-swipe__dot');
    var images = card.querySelectorAll('.avalna-card-swipe__img');

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        avalnaLoadCardImages(card);
        avalnaSetActiveImage(images, dots, i);
      });
    });
  }

  function avalnaBindHover(card) {
    var images = card.querySelectorAll('.avalna-card-swipe__img');
    if (images.length < 2) return;

    card.addEventListener('mouseenter', function () {
      avalnaLoadCardImages(card);
      var dots = card.querySelectorAll('.avalna-card-swipe__dot');
      avalnaSetActiveImage(images, dots, 1);
    });

    card.addEventListener('mouseleave', function () {
      var dots = card.querySelectorAll('.avalna-card-swipe__dot');
      avalnaSetActiveImage(images, dots, 0);
    });
  }

  function avalnaGetActiveIndex(images) {
    for (var i = 0; i < images.length; i++) {
      if (images[i].classList.contains('avalna-card-swipe__img--active')) return i;
    }
    return 0;
  }

  function avalnaSetActiveImage(images, dots, index) {
    images.forEach(function (img, i) {
      img.classList.toggle('avalna-card-swipe__img--active', i === index);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('avalna-card-swipe__dot--active', i === index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaCardSwipeInit);
  } else {
    avalnaCardSwipeInit();
  }
})();
